"use client";

import Button from "@/components/atoms/Button";
import styles from "./styles.module.scss";
import Markdown from "@/components/atoms/Markdown";
import BulletsMarkdown from "@/components/atoms/BulletsMarkdown/BulletsMarkdown";
import cn from "clsx";
import { pushToDataLayer } from "@/helpers/gtag";
import SectionCardHeader from "../SectionCardHeader";

export default function CourseStructureSection({
  CourseStructure,
  PerSemStructure,
}) {
  if (!CourseStructure?.enabled) return null;
  const handleClick = () => {
    pushToDataLayer(
      {
        event: "enquire_now_enroll_now_cta_click",
        cta_text: CourseStructure?.CTAText || "NA",
        section_name: CourseStructure?.Title?.replace(/\n/gi, "  \n") || "NA",
        page_type: "Campaign Page",
      }
    )
  }
  return (
    <SectionCardHeader
      hideHr
      isCard
      wide
      rootClassName={styles.root}
      Title={CourseStructure?.Title}
    >
      <div className="basis-2/5">
        <Markdown className={styles.title}>
          {CourseStructure?.Title?.replace(/\n/gi, "  \n")}
        </Markdown>
        <Button
          buttonProps={{
            onClick:handleClick,
            href: CourseStructure?.CTAUrl || "#",
            target: "_" + CourseStructure?.CTATarget || "_self",
            scroll: true,
          }}
          className={cn(styles.ctaBtn, 'mx-5')}
          icon="/_a/icons/left-arrow-blue-down.svg"
          hoverIcon="/_a/icons/arrow-down-white.svg"
          bg="o"
        >
          {CourseStructure?.CTAText}
        </Button>

        <img
          src={CourseStructure?.Image?.data?.attributes?.url}
          alt={CourseStructure?.Image?.data?.attributes?.alternativeText || ''}
          className={styles.image}
          loading="lazy"
        />
      </div>
      <div className={cn(styles.container, "basis-3/5")}>
        {PerSemStructure?.filter((x) => x?.enabled)?.map((item, index) => (
          <div className={styles.bulletContainer} key={index}>
            <p className={styles.bulletHeading}>{item?.Heading}</p>
            <BulletsMarkdown classNames={styles.bullets}>
              {item?.Content}
            </BulletsMarkdown>
          </div>
        ))}
      </div>
    </SectionCardHeader>
  );
}
